import {
  WS_KEY,
  readWorkspaceLocal,
  writeWorkspaceLocal,
  removeWorkspaceLocal,
} from "./workspaceStorage";

export function loadActiveHygieneJob() {
  try {
    const raw = readWorkspaceLocal(WS_KEY.HYGIENE_ACTIVE_JOB);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.jobId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveActiveHygieneJob({
  jobId,
  startedAt,
  scope,
  impactCount,
  mode,
  rulesCount,
  phase,
}) {
  if (!jobId) return;
  const prev = loadActiveHygieneJob();
  writeWorkspaceLocal(
    WS_KEY.HYGIENE_ACTIVE_JOB,
    JSON.stringify({
      jobId: String(jobId),
      startedAt: startedAt || prev?.startedAt || new Date().toISOString(),
      scope: scope ?? prev?.scope,
      impactCount: impactCount ?? prev?.impactCount,
      mode: mode ?? prev?.mode,
      rulesCount: rulesCount ?? prev?.rulesCount,
      phase: phase ?? prev?.phase ?? "running",
    })
  );
}

export function clearActiveHygieneJob() {
  removeWorkspaceLocal(WS_KEY.HYGIENE_ACTIVE_JOB);
}
